$(function () {
  // sliderクラスに対して、slickを初期化する。（autoplay等のオプションは、記述しない場合デフォルト値になる。）
  $("#top_mv_slide .slider").slick({
    // スライドの自動再生を有効にする （デフォルト値： false）
    autoplay: true,

    // 自動再生のスピード（ミリ秒単位） （デフォルト値： 3000）
    autoplaySpeed: 3000,

    // スライドのナビゲーションにドットを表示 （デフォルト値：false）
    dots: true,

    // スライドのナビゲーションに矢印を表示 （デフォルト値：true）
    arrows: true,

    // スライドの切り替え時にフェード効果を使用 （デフォルト値：false）
    fade: false,

    // スライドの切り替えにかかる時間（ミリ秒単位） （デフォルト値: 300）
    speed: 300,

    // スライダーの項目を一度に表示する数 （デフォルト値: 1）
    slidesToShow: 1,

    // スライダーの項目を切り替える際にスライドする数 （デフォルト値: 1）
    slidesToScroll: 1,

    // スライダーがリサイズする際に自動的に調整 （デフォルト値: false）
    adaptiveHeight: false,

    // スライダーが最初に表示されるインデックス（0から始まる） （デフォルト値: 0）
    initialSlide: 0,

    // スライダーがループするかどうか （デフォルト値: true）
    infinite: true, // falseにすると、スライダーが終わってもループしない

    // スライダーのアイテムが画面に収まるように調整 （デフォルト値: false）
    centerMode: true,  //現在のスライドを中央に配置 falseにすると、ズレる
    centerPadding: "20%", // 左右に20%ずつ見せる

    // スライダーをレスポンシブにするための設定 （デフォルト値: 空配列（レスポンシブ設定なし））
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: "10%", // SPは10%くらいが見やすい
        }
}

      // {
      //     breakpoint: 768, // 768px以下のスクリーン幅に対する設定
      //     settings: {
      //         slidesToShow: 2,
      //         slidesToScroll: 2,
      //         dots: true
      //     }
      // },
      // {
      //     breakpoint: 480, // 480px以下のスクリーン幅に対する設定
      //     settings: {
      //         slidesToShow: 1,
      //         slidesToScroll: 1,
      //         dots: true
      //     }
      // }
    ],
  });
});
